import * as React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "react-toastify";
import axios from "axios";

export function ForgotPasswordForm() {
  const [email, setEmail] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const requestPasswordReset = async (email: string): Promise<void> => {
    try {
      const response = await axios.post("/common/auth/request-password-reset", {
        email,
      });
      return response.data; // Vous pouvez traiter la réponse si nécessaire
    } catch (error) {
      console.error("Erreur lors de la réinitialisation du mot de passe", error);
      throw new Error("Échec de la demande de réinitialisation du mot de passe.");
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event: React.SyntheticEvent) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      await requestPasswordReset(email);
      toast.success("Email de réinitialisation envoyé.");
    } catch (error) {
      toast.error("Erreur lors de la demande de réinitialisation.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="grid gap-6">
      <form onSubmit={handleSubmit}>
        <div className="grid gap-1">
          <Label htmlFor="email">Entrez votre email pour réinitialiser le mot de passe</Label>
          <Input
            id="email"
            type="email"
            placeholder="nom@exemple.fr"
            value={email}
            onChange={handleEmailChange}
            disabled={isLoading}
          />
        </div>

        <Button type="submit" disabled={isLoading} className="mt-6">
          {isLoading ? "Envoi en cours..." : "Envoyer l'e-mail de réinitialisation"}
        </Button>
      </form>
    </div>
  );
}
